/**
 * PUBLIC variant of the MapPage.
 *
 * Changes:
 * - Removed MapSidebar
 * - Removed selectStation
 * - Removed onViewportChanged
 */

import React, { useRef } from "react"
import { Map as Leaflet, Marker, Tooltip } from "react-leaflet"

import * as consts from "../constants"
import { DefaultTileLayer } from "../components/Leaflet"
import { useStoreData, useVariant } from "../hooks"

import { MapMarkers, useLeafletRenderFix } from "./MapPageShared"

import "./MapPage.scss"

export default function MapPage() {
    const mapRef = useRef()
    const mapFocus = useStoreData("mapFocus")
    const filter = useStoreData("filter")
    const viewState = useStoreData("viewState")
    const { isFull } = useVariant()

    useLeafletRenderFix(mapRef)

    return (
        <div className="MapPage">
            <div className="MapContainer">
                <Leaflet
                    center={mapFocus}
                    zoom={mapFocus.zoom}
                    minZoom={consts.ZOOM_MIN}
                    maxZoom={consts.ZOOM_MAX}
                    doubleClickZoom={false}
                    ref={mapRef}
                >
                    <DefaultTileLayer dark />

                    {mapFocus.marker ? (
                        <Marker
                            position={[
                                mapFocus.marker.lat,
                                mapFocus.marker.lng,
                            ]}
                        >
                            <Tooltip>{mapFocus.marker.title}</Tooltip>
                        </Marker>
                    ) : null}

                    {filter.showStations ? (
                        <MapMarkers objects={viewState.visibleStations} />
                    ) : null}
                    {filter.showGrosskunden && isFull ? (
                        <MapMarkers objects={viewState.visibleGrosskunden} />
                    ) : null}
                    {filter.showKritinfra && isFull ? (
                        <MapMarkers objects={viewState.visibleKritinfra} />
                    ) : null}
                    {filter.showConstructionSites ? (
                        <MapMarkers
                            objects={viewState.visibleConstructionSites}
                        />
                    ) : null}
                    {filter.showPowerQualityDrops ? (
                        <MapMarkers
                            displaymode="powerQualityDrop"
                            objects={viewState.visiblePowerQualities}
                        />
                    ) : null}
                </Leaflet>
            </div>
        </div>
    )
}
